import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../services/user';



@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss',
})

export class HomepageComponent implements OnInit {
  contentReady: boolean = false;

  showWheel = false;
  userId!: any;
  constructor(
    private userService: UserService) {

  }

  ngOnInit(): void {

    this.userService.getUserId().subscribe({
      next: (data) => {
        this.userId = data.user_id;
      },
      error: () => {
        this.userId = null as any;
      }
    });

  }







}
